module.exports = __webpack_public_path__ + "img/sh.42100063.svg";